.Text {
    margin: 0;
    font-family: var(--soniq-t--global--font--family--sans);

    &.isPageTitle {
        font-size: var(--soniq-t--global--font--size--page-title);
        font-weight: var(--soniq-t--global--font--weight--semibold);
        letter-spacing: var(--soniq-t--global--font--letter-spacing--tight);
        color: var(--soniq-t--global--text--color--primary--default);
    }

    /* The large title under a dialog's eyebrow label */
    &.isDialogTitle {
        font-size: var(--soniq-t--global--font--size--page-title);
        font-weight: var(--soniq-t--global--font--weight--bold);
        letter-spacing: var(--soniq-t--global--font--letter-spacing--tight);
        color: var(--soniq-t--global--text--color--primary--default);
    }

    &.isSectionTitle {
        font-size: var(--soniq-t--global--font--size--section-title);
        font-weight: var(--soniq-t--global--font--weight--semibold);
        color: var(--soniq-t--global--text--color--primary--default);
    }

    &.isSectionTitleSupporting {
        font-size: var(--soniq-t--global--font--size--section-title-supporting);
        font-style: italic;
        color: var(--soniq-t--global--text--color--hint--default);
    }

    &.isSectionHeader {
        font-size: var(--soniq-t--global--font--size--body);
        font-weight: var(--soniq-t--global--font--weight--medium);
        letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
        text-transform: uppercase;
        color: var(--soniq-t--global--text--color--label--default);
    }

    &.isInvoiceNumber {
        font-size: var(--soniq-t--global--font--size--body);
        font-weight: var(--soniq-t--global--font--weight--medium);
        color: var(--soniq-t--global--text--color--brand--default);
    }

    &.isAmount {
        font-size: var(--soniq-t--global--font--size--amount);
        font-weight: var(--soniq-t--global--font--weight--semibold);
        color: var(--soniq-t--global--text--color--primary--default);
    }

    &.isBody {
        font-size: var(--soniq-t--global--font--size--body);
        font-weight: var(--soniq-t--global--font--weight--regular);
        color: var(--soniq-t--global--text--color--body--default);
    }

    &.isSupporting {
        font-size: var(--soniq-t--global--font--size--date);
        font-weight: var(--soniq-t--global--font--weight--regular);
        color: var(--soniq-t--global--text--color--hint--default);
    }

    &.isDate {
        font-size: var(--soniq-t--global--font--size--date);
        font-weight: var(--soniq-t--global--font--weight--regular);
        color: var(--soniq-t--global--text--color--secondary--default);
    }

    &.isFieldLabel {
        font-size: var(--soniq-t--global--font--size--field-label);
        font-weight: var(--soniq-t--global--font--weight--regular);
        letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
        color: var(--soniq-t--global--text--color--field--default);
    }

    /* The list items are plain `li` elements */
    &.isList,
    &.isOrderedList {
        display: flex;
        flex-direction: column;
        gap: 0.5em;
        padding-left: 1.25em;
        font-size: var(--soniq-t--global--font--size--body);
        font-weight: var(--soniq-t--global--font--weight--regular);
        color: var(--soniq-t--global--text--color--body--default);
    }

    /* Content Section Variants */

    &.isEyebrow,
    &.isContentHeroEyebrow {
        font-size: 0.75rem;
        font-weight: var(--soniq-t--global--font--weight--semibold);
        letter-spacing: 0.1em;
        text-transform: uppercase;
    }

    &.isEyebrow {
        color: var(--soniq-t--global--text--color--brand--default);
    }

    &.isContentHeroEyebrow {
        color: var(--soniq-t--global--text--color--blockbg--contrast);
    }

    &.isContentHeroSupporting {
        color: var(--soniq-t--global--text--color--blockbg--contrast);
        font-size: var(--soniq-t--global--font--size--content-section-supporting);
        line-height: 1.75;
    }

    &.isContentSectionSupporting {
        color: var(--soniq-t--global--text--color--hint--default);
        font-size: var(--soniq-t--global--font--size--content-section-supporting);
        line-height: 1.75;
    }
}
